import { render, staticRenderFns } from "./qualityDetails.vue?vue&type=template&id=77148ad0&scoped=true&"
import script from "./qualityDetails.vue?vue&type=script&lang=js&"
export * from "./qualityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77148ad0",
  null
  
)

export default component.exports